export enum FileType {
	ANY = 'any',
	IMAGE = 'image',
	PDF = 'pdf',
	DOCUMENT = 'document',
	VIDEO = 'video',
	SOUND = 'sound',
}

export interface UploadedFile {
	url: string;
	base64: string;
	raw: File;
}

export enum FileUploadErrorType {
	SIZE = 'size',
	TYPE = 'type',
	BASE64 = 'base64',
}
